import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { BranchMinimumCartSystemAdminDto } from '@/backend/market'
import { BranchMinimumCartSystemEntity } from '../../domain/entities/BranchMinimumCartSystemEntity'

export class BranchMinimumCartSystemModel extends BranchMinimumCartSystemEntity {
  constructor(dataDto: BranchMinimumCartSystemAdminDto) {
    super()
    mapEntityProperties<BranchMinimumCartSystemModel>(this, dataDto)
  }
}
